jQuery(document).ready(function () {
  jQuery(document).on("click", ".header-search-btn", charlToggleSearchOverlay);
  jQuery(document).on(
    "click",
    ".search-overlay-close, .search-overlay-backdrop",
    charlCloseSearchOverlay
  );

  jQuery("#charl-search-input").keyup(delay(ajaxSearch, 500));

  jQuery("#charl-search-input").on("search", ajaxClearSearch);

  // Prevent form submission (and page redirect) when pressing Enter in the search overlay
  jQuery(document).on("submit", ".search-overlay form", function (e) {
    e.preventDefault();
  });

  jQuery("#charl-searchpage-input").keyup(delay(ajaxSearch, 500));

  jQuery("#charl-searchpage-input").on("search", ajaxClearSearch);

  /**
   * Handle "Show all results" button click
   */
  jQuery(document).on('click', '.charl-show-all-results', function(e) {
      e.preventDefault();
      
      let $button = jQuery(this);
      let keyword = $button.data('keyword');
      
      jQuery.ajax({
          beforeSend: function () {
              jQuery(".search-loading").removeClass('hidden');
              $button.prop('disabled', true);
          },
          url: ajaxurl,
          type: 'post',
          data: { 
              action: 'charl_search_results', 
              keyword: keyword, 
              perPage: -1,
              showAll: 1
          },
          success: function (data) {
              jQuery('#charl_search_results').html(data);
              jQuery(".search-loading").addClass('hidden');
              
              // Scroll to top of results
              let $resultsList = jQuery('#search-results-list');
              if ($resultsList.length) {
                  $resultsList.animate({ scrollTop: 0 }, 300);
              }
          }
      });
  });
});

/**
 * Toggle the search overlay visibility
 */
function charlToggleSearchOverlay(e) {
  jQuery(".search-overlay").toggleClass("hidden");

  // Focus on search input when opening
  if (!jQuery(".search-overlay").hasClass("hidden")) {
    setTimeout(function () {
      jQuery(".search-overlay input[type='search']").focus();
    }, 100);
  }

  e.preventDefault();
}

/**
 * Close the search overlay
 */
function charlCloseSearchOverlay(e) {
  jQuery(".search-overlay").addClass("hidden");
  e.preventDefault();
}

function ajaxSearch(e) {
  let perPage = 2;
  let paginate = 0;

  console.log(e.target);

  if (e.target.id == 'charl-searchpage-input') {
    perPage = 5;
    paginate = 1;
  }
  if (jQuery(this).val() == '') {
    ajaxClearSearch(e);
  }
  else {
    jQuery.ajax({
      beforeSend: function () {
        jQuery(".search-loading").removeClass('hidden');
      },
      url: ajaxurl,
      type: 'post',
      data: { action: 'charl_search_results', keyword: jQuery(this).val(), perPage: perPage, paginate: paginate },
      success: function (data) {
        if (e.target.id == 'charl-searchpage-input') {
          jQuery('#charl_searchpage_results').html(data);
        }
        else {
          jQuery('#charl_search_results').html(data);
        }

        jQuery(".search-loading").addClass('hidden');
      }
    });
  }
}

function ajaxClearSearch(e) {
  if (e.target.id == 'charl-searchpage-input') {
    jQuery('#charl_searchpage_results').empty();
  }
  else {
    jQuery('#charl_search_results').empty();
  }
}

function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId = setTimeout(function () {
    method();
  }, delay);
}

function delay(callback, ms) {
  var timer = 0;
  return function () {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}
